const navigationPalette = (tokens) => {
    return {
        container: {
            primary: {
                background: {
                    default: tokens.navigationNavContainerPrimaryColorBg
                },
                border: {
                    width: tokens.navigationNavContainerPrimaryBorderWidth,
                    default: tokens.navigationNavContainerPrimaryColorBorder,
                    radius: tokens.navigationNavContainerPrimaryRadius
                },
                padding: tokens.navigationNavContainerPrimaryPadding,
                width: tokens.navigationNavContainerPrimaryWidth,
                spaceBetween: tokens.navigationNavContainerPrimarySpaceBetween
            },
            secondary: {
                background: {
                    default: tokens.navigationNavContainerSecondaryColorBg
                },
                border: {
                    width: tokens.navigationNavContainerSecondaryBorderWidth,
                    default: tokens.navigationNavContainerSecondaryColorBorder,
                    radius: tokens.navigationNavContainerSecondaryRadius
                },
                padding: tokens.navigationNavContainerSecondaryPadding,
                width: tokens.navigationNavContainerSecondaryMinWidth,
                spaceBetween: tokens.navigationNavContainerSecondarySpaceBetween
            }
        },
        logo: {
            paddingTop: tokens.aliasesSpaceContainerSpacious,
            paddingBottom: tokens.aliasesSpaceContainerDefault
        },
        accountSwitcher: {
            border: {
                width: tokens.navigationAccountSwitcherBorderWidthDefault,
                radius: {
                    top: tokens.navigationAccountSwitcherRadiusTop,
                    bottom: tokens.navigationAccountSwitcherRadiusBottom
                }
            },
            font: {
                family: tokens.navigationAccountSwitcherFontFamily,
                size: tokens.navigationAccountSwitcherFontSize,
                weight: tokens.navigationAccountSwitcherFontWeight,
                lineHeight: tokens.navigationAccountSwitcherLineHeight,
                letterSpacing: tokens.navigationAccountSwitcherLetterspacing
            },
            color: {
                background: {
                    default: tokens.navigationAccountSwitcherColorBgDefault,
                    hover: tokens.navigationAccountSwitcherColorBgHover,
                    disabled: tokens.navigationAccountSwitcherColorBgDisabled,
                    selected: tokens.navigationAccountSwitcherColorBgSelected,
                    focus: tokens.navigationAccountSwitcherColorBgFocus
                },
                border: {
                    default: tokens.navigationAccountSwitcherColorBorderDefault,
                    hover: tokens.navigationAccountSwitcherColorBorderHover,
                    disabled: tokens.navigationAccountSwitcherColorBorderDisabled,
                    selected: tokens.navigationAccountSwitcherColorBorderSelected,
                    focus: tokens.navigationAccountSwitcherColorBorderFocus
                },
                text: {
                    default: tokens.navigationAccountSwitcherColorTextDefault,
                    disabled: tokens.navigationAccountSwitcherColorTextDisabled,
                    selected: tokens.navigationAccountSwitcherColorTextSelected
                }
            }
        }
    };
};
export default navigationPalette;
//# sourceMappingURL=navigation.js.map